import { useMutation, useQueryClient } from "@tanstack/react-query";
import { getUsersApiClient } from "@shared/apis/sidekick/api-factories";
import { GET_USER_BRANDING_QUERY_KEY } from "./useGetUserBranding";
import { toast } from "@shared/services/toast";

type UseUpsertUserBrandingProps = {
  onSuccess?: (data: Params) => void;
};

type Params = {
  agentName?: string | null;
  agentEmail?: string | null;
  agentTitle?: string | null;
  agentAvatar?: string | null;
  agentMlsId?: string | null;
  agentPhoneNumber?: string | null;
  officeName?: string | null;
  officeLogo?: string | null;
  website?: string | null;
  teamName?: string | null;
  teamLogo?: string | null;
  instagramUrl?: string | null;
  facebookUrl?: string | null;
  xUrl?: string | null;
  youtubeUrl?: string | null;
  linkedInUrl?: string | null;
};

export const useUpsertUserBranding = (props?: UseUpsertUserBrandingProps) => {
  const { onSuccess } = props || {};
  const api = getUsersApiClient();
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: async (params: Params) => {
      const response = await api.userControllerUpdateBranding({
        updateMyBrandingRequest: params,
      });
      queryClient.invalidateQueries({
        queryKey: [GET_USER_BRANDING_QUERY_KEY],
      });
      onSuccess?.(params);
      return response;
    },
    onError: (error) => {
      toast.error("Failed to update branding.");
      console.error(`Failed to update branding`, error);
    },
    mutationKey: ["upsert-user-branding"],
  });

  return mutation;
};
